import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CircularProgress } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { viewIndustry } from '../../redux';

const ViewDetails = (props) => {

  const viewResult = useSelector((state) => state.industry.viewResult);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    if(loading && props.modalDiaLogId && props.modalDiaLogId > 0) {
      dispatch(viewIndustry(props.modalDiaLogId));
      setLoading(false);
    }
  }, [props, loading, viewResult, dispatch]);


  const details = (
    loading === false && viewResult ?
    <ul className="list-group">
    <li className="list-group-item"><strong className="p-2">IndustryId:</strong> {viewResult.id}</li>
    <li className="list-group-item"><strong className="p-2">IndustryName:</strong> {viewResult.industryName}</li>
    <li className="list-group-item"><strong className="p-2">Active:</strong> {viewResult.active ? "YES" : "NO"}</li>
    <li className="list-group-item"><strong className="p-2">IndustryLogo:</strong> {viewResult.industryPicture !== null && viewResult.industryPicture !== '' ? <img className="float-end" alt={viewIndustry.industryName} src={viewResult.industryPictureUrl} /> : 'NOT SET' } </li>
  </ul> : <CircularProgress /> )

  return (
    <>
    <DialogContent sx={{ marginTop: "-10px" }} >
      { details }
    </DialogContent>
    <DialogActions>
      <button className="btn btn-secondary" onClick={ () => props.setOpen(false) } >Close</button>
    </DialogActions>
    </>
  )

}

export default ViewDetails;
